import {Component} from '@angular/core';
import {LeftViewComponent} from '../left-view/left-view.component';
import {RouterOutlet} from '@angular/router';
import {FooterComponent} from '../footer/footer.component';
import {SearchComponent} from '../search/search.component'

@Component({
  selector: 'app-report-main',
  templateUrl: './report-main.component.html',
  imports: [
    LeftViewComponent,
    RouterOutlet,
    FooterComponent,
    SearchComponent
  ],
  styleUrls: ['./report-main.component.scss']
})
export class ReportMainComponent {}
